import { RouteConfig } from 'vue-router';
import AdminRegisterLayout from '@/views/AdminRegisterLayout.vue';
import AdminRegisterLayoutIframe from '@/views/AdminRegisterLayoutIframe.vue';

export default (): RouteConfig[] => {
  return [
    {
      path: '/admin-register/:type',
      component: AdminRegisterLayoutIframe,
      meta: {
        nonMember: true,
      },
    },
    {
      path: '/admin-register',
      name: 'AdminRegister',
      component: AdminRegisterLayoutIframe,
      meta: {
        nonMember: true,
      },
    },
    {
      path: '/admin-register-prev',
      name: 'AdminRegisterPrev',
      component: AdminRegisterLayout,
      meta: {
        nonMember: true,
      },
    },
  ];
};
